<template lang="pug">
#Hispanic.container-fluid
  //- #Header.row.valign-wrapper
  //-   .col.s12.center
  //-     br
  //-     img#mainLogo(src="../assets/hipspanic_r.png")
  #content.relative
    img(src="../assets/desktop/Hipspanic/Hipspanic Fixed.svg")

    //- svg(version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 1366 768' style='enable-background:new 0 0 1366 768;width: 100%;transform: translate(9%,0) scale(1.2);padding-bottom: 2vh;' xml:space='preserve')
    //-   rect.st0(x='105.2' y='127' width='263.2' height='31.3')
    //-   g
    //-     g
    //-       polygon(points='510.1,367.3 503.6,367.3 528.9,314.8 535.4,314.8 		')
    //-       rect(x='187.3' y='314.8' width='10.9' height='10.9')
    //-       rect(x='251.7' y='342.6' width='10.9' height='10.9')
    //-       rect(x='431.9' y='342.6' width='10.9' height='10.9')
    //-       rect(x='449.2' y='314.8' width='11' height='11')
    //-       path(d='M169.9,367.3v-21.4c0-2.6-0.6-4.5-1.7-5.8c-1.2-1.3-2.8-2-4.9-2c-2.1,0-3.8,0.7-5,2c-1.2,1.3-1.8,3.3-1.8,5.8v21.4h-10.9\
    //-       v-52.5h10.9v19.5c0.6-0.8,1.3-1.6,2.1-2.4c0.7-0.7,1.6-1.4,2.5-2c0.9-0.6,1.9-1,3-1.4c1.1-0.3,2.4-0.5,3.7-0.5\
    //-       c4.2,0,7.4,1.3,9.7,3.8c2.3,2.5,3.4,6,3.4,10.5v25H169.9z')
    //-       path(d='M187.3,367.3v-38.5h10.9v38.5H187.3z')
    //-       path.st0(d='M243.7,356.6c-1,2.5-2.3,4.6-3.9,6.3c-1.6,1.7-3.5,3-5.6,3.8c-2.1,0.9-4.3,1.3-6.6,1.3\
    //-       c-2.9,0-5.3-0.6-7.2-1.7c-1.9-1.1-3.5-2.5-4.8-4v16.5h-10.9v-50.1h10.9v5.5c1.3-1.8,3-3.3,4.9-4.5c1.9-1.2,4.3-1.7,7.2-1.7\
    //-       c2.3,0,4.4,0.4,6.5,1.3c2.1,0.9,4,2.1,5.6,3.8s2.9,3.8,3.9,6.3c1,2.5,1.5,5.3,1.5,8.5v0.1C245.1,351.3,244.6,354.2,243.7,356.6z\
    //-       M234.2,348c0-1.6-0.3-3.1-0.8-4.4c-0.5-1.3-1.2-2.5-2-3.4c-0.9-0.9-1.9-1.7-3-2.2c-1.1-0.5-2.3-0.8-3.6-0.8\
    //-       c-1.3,0-2.5,0.3-3.6,0.8c-1.1,0.5-2.1,1.2-2.9,2.2c-0.8,0.9-1.5,2.1-2,3.4c-0.5,1.3-0.8,2.8-0.8,4.4v0.1c0,1.6,0.3,3.1,0.8,4.4\
    //-       c0.5,1.3,1.2,2.5,2,3.4c0.8,0.9,1.8,1.7,2.9,2.2s2.3,0.8,3.6,0.8c1.3,0,2.5-0.3,3.6-0.8c1.1-0.5,2.1-1.2,3-2.2\
    //-       c0.9-0.9,1.5-2.1,2-3.4c0.5-1.3,0.8-2.8,0.8-4.4V348z')
    //-       path(d='M297.4,361c-0.7,1.6-1.8,2.8-3.1,3.8c-1.3,1-2.9,1.8-4.7,2.3c-1.8,0.5-3.7,0.8-5.8,0.8c-2.7,0-5.5-0.5-8.4-1.4\
    //-       c-2.9-0.9-5.6-2.4-8.2-4.4l4.7-7.2c2.1,1.5,4.2,2.7,6.3,3.5c2.1,0.8,4,1.2,5.9,1.2c1.6,0,2.7-0.3,3.5-0.8c0.7-0.5,1.1-1.2,1.1-2.1\
    //-       v-0.1c0-0.6-0.2-1.1-0.6-1.5s-1-0.8-1.8-1.1c-0.7-0.3-1.6-0.6-2.6-0.9c-1-0.3-2-0.6-3-0.9c-1.3-0.4-2.7-0.8-4.1-1.4\
    //-       c-1.4-0.6-2.6-1.3-3.7-2.2c-1.1-0.9-2-2-2.7-3.3c-0.7-1.3-1-2.9-1-4.7v-0.1c0-2,0.4-3.7,1.1-5.2c0.7-1.5,1.7-2.8,3-3.8\
    //-       c1.3-1.1,2.8-1.8,4.5-2.4c1.7-0.5,3.5-0.8,5.5-0.8c2.4,0,4.9,0.4,7.4,1.2c2.5,0.8,4.8,1.9,6.9,3.3l-4.2,7.6\
    //-       c-1.9-1.1-3.8-2-5.6-2.6c-1.8-0.6-3.4-1-4.8-1c-1.3,0-2.4,0.3-3,0.8c-0.7,0.5-1,1.1-1,1.9v0.1c0,0.5,0.2,1,0.6,1.4\
    //-       c0.4,0.4,1,0.8,1.7,1.2c0.7,0.4,1.5,0.7,2.5,1c0.9,0.3,1.9,0.7,3,1c1.3,0.4,2.7,0.9,4.1,1.5c1.4,0.6,2.6,1.3,3.7,2.2\
    //-       c1.1,0.9,2,1.9,2.7,3.2c0.7,1.2,1.1,2.8,1.1,4.5v0.1C298.5,357.6,298.1,359.5,297.4,361z')
    //-       path(d='M342.1,356.6c-1,2.5-2.3,4.6-3.9,6.3c-1.6,1.7-3.5,3-5.6,3.8c-2.1,0.9-4.3,1.3-6.6,1.3c-2.9,0-5.3-0.6-7.2-1.7\
    //-       c-1.9-1.1-3.5-2.5-4.8-4v16.5h-10.9v-50.1H314v5.5c1.3-1.8,3-3.3,4.9-4.5c1.9-1.2,4.3-1.7,7.2-1.7c2.3,0,4.4,0.4,6.5,1.3\
    //-       c2.1,0.9,4,2.1,5.6,3.8c1.6,1.7,2.9,3.8,3.9,6.3c1,2.5,1.5,5.3,1.5,8.5v0.1C343.5,351.3,343,354.2,342.1,356.6z M332.6,348\
    //-       c0-1.6-0.3-3.1-0.8-4.4c-0.5-1.3-1.2-2.5-2-3.4c-0.9-0.9-1.9-1.7-3-2.2c-1.1-0.5-2.3-0.8-3.6-0.8c-1.3,0-2.5,0.3-3.6,0.8\
    //-       c-1.1,0.5-2.1,1.2-2.9,2.2c-0.8,0.9-1.5,2.1-2,3.4c-0.5,1.3-0.8,2.8-0.8,4.4v0.1c0,1.6,0.3,3.1,0.8,4.4c0.5,1.3,1.2,2.5,2,3.4\
    //-       c0.8,0.9,1.8,1.7,2.9,2.2s2.3,0.8,3.6,0.8c1.3,0,2.5-0.3,3.6-0.8c1.1-0.5,2.1-1.2,3-2.2c0.9-0.9,1.5-2.1,2-3.4\
    //-       c0.5-1.3,0.8-2.8,0.8-4.4V348z')
    //-       path(d='M373.2,367.2V363c-1.3,1.5-2.9,2.7-4.8,3.6c-1.9,0.9-4.1,1.3-6.8,1.3c-1.8,0-3.5-0.3-5.1-0.8c-1.6-0.5-3-1.3-4.2-2.3\
    //-       c-1.2-1-2.1-2.2-2.8-3.7c-0.7-1.5-1-3.2-1-5.1V356c0-2.1,0.4-3.9,1.2-5.5c0.8-1.5,1.8-2.8,3.2-3.8c1.4-1,3-1.8,4.9-2.3\
    //-       c1.9-0.5,4-0.8,6.3-0.8c2,0,3.7,0.1,5.1,0.4c1.5,0.3,2.9,0.7,4.3,1.2v-0.6c0-2.3-0.7-4-2.1-5.2c-1.4-1.2-3.5-1.8-6.2-1.8\
    //-       c-2.1,0-4,0.2-5.6,0.5c-1.6,0.4-3.3,0.9-5.1,1.5l-2.7-8.3c2.1-0.9,4.3-1.7,6.6-2.2c2.3-0.6,5.1-0.9,8.3-0.9c6,0,10.4,1.5,13.1,4.4\
    //-       c2.7,2.9,4.1,7,4.1,12.2v22.4H373.2z M373.4,351.7c-1-0.4-2-0.8-3.2-1c-1.2-0.3-2.4-0.4-3.8-0.4c-2.3,0-4.2,0.5-5.5,1.4\
    //-       c-1.3,0.9-2,2.2-2,4v0.1c0,1.5,0.6,2.6,1.7,3.5c1.1,0.8,2.5,1.2,4.3,1.2c2.6,0,4.7-0.6,6.2-1.9c1.6-1.2,2.3-2.9,2.3-4.9V351.7z')
    //-       path(d='M414.5,367.3v-21.4c0-2.6-0.6-4.5-1.7-5.8c-1.2-1.3-2.8-2-4.9-2c-2.1,0-3.8,0.7-5,2c-1.2,1.3-1.8,3.3-1.8,5.8v21.4h-10.9\
    //-       v-38.5h10.9v5.5c0.6-0.8,1.3-1.6,2.1-2.4c0.7-0.7,1.6-1.4,2.5-2c0.9-0.6,1.9-1,3-1.4c1.1-0.3,2.4-0.5,3.7-0.5\
    //-       c4.2,0,7.4,1.3,9.7,3.8c2.3,2.5,3.4,6,3.4,10.5v25H414.5z')
    //-       path(d='M449.2,367.3v-38.5h10.9v38.5H449.2z')
    //-       path(d='M494,365.3c-2.3,1.3-5.3,1.9-9,1.9c-2.8,0-5.3-0.5-7.7-1.5c-2.4-1-4.4-2.4-6.1-4.1c-1.7-1.7-3-3.8-4-6.1\
    //-       c-1-2.3-1.5-4.8-1.5-7.4v-0.1c0-2.6,0.5-5.1,1.5-7.5c1-2.4,2.3-4.4,4-6.2c1.7-1.8,3.7-3.1,6.1-4.2c2.4-1,5-1.5,7.9-1.5\
    //-       c3.5,0,6.4,0.6,8.7,1.7c2.3,1.1,4.3,2.6,6.1,4.6l-6.4,6.9c-1.2-1.2-2.4-2.2-3.7-3c-1.3-0.7-2.9-1.1-4.7-1.1\
    //-       c-1.3,0-2.6,0.3-3.6,0.8c-1.1,0.5-2,1.3-2.8,2.2c-0.8,0.9-1.4,2-1.9,3.2c-0.4,1.2-0.7,2.5-0.7,3.9v0.1c0,1.4,0.2,2.8,0.7,4\
    //-       c0.4,1.2,1.1,2.3,1.9,3.3c0.8,0.9,1.8,1.7,3,2.2c1.2,0.5,2.4,0.8,3.9,0.8c1.8,0,3.3-0.4,4.6-1.1c1.3-0.7,2.6-1.7,3.9-2.9l6.2,6.2\
    //-       C498.4,362.4,496.3,364.1,494,365.3z')
    //-       polygon(points='115.7,367.3 109.2,367.3 134.5,314.8 141,314.8 		')
    //-     g
    //-       path(d='M527.5,357.9c1.4,0,2.6,0.5,3.5,1.4c0.9,0.9,1.4,2,1.4,3.3c0,1.3-0.5,2.4-1.4,3.3c-0.9,0.9-2,1.4-3.3,1.4\
    //-       c-1.3,0-2.4-0.5-3.3-1.4s-1.4-2-1.4-3.3c0-0.9,0.2-1.7,0.7-2.5c0.5-0.8,1.1-1.3,1.8-1.7C526.2,358.1,526.9,357.9,527.5,357.9z\
    //-       M527.8,358.8c-1.2,0-2.1,0.4-2.8,1.1s-1.1,1.6-1.1,2.6c0,1,0.4,1.9,1.1,2.7c0.7,0.7,1.6,1.1,2.7,1.1c1,0,1.9-0.4,2.7-1.1\
    //-       c0.7-0.7,1.1-1.6,1.1-2.7c0-0.7-0.2-1.4-0.6-2s-0.8-1.1-1.4-1.4C528.9,359,528.3,358.8,527.8,358.8z M525.6,365.1v-5h2.4\
    //-       c0.6,0,1,0.1,1.3,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.3,0.9c-0.2,0.2-0.6,0.4-1,0.5c0.2,0.1,0.4,0.2,0.5,0.3\
    //-       c0.1,0.1,0.3,0.4,0.6,0.9l0.6,1h-1.2l-0.4-0.8c-0.2-0.5-0.5-0.8-0.7-1c-0.2-0.2-0.4-0.3-0.7-0.3h-0.3v2H525.6z M526.6,362.3h0.8\
    //-       c0.4,0,0.7-0.1,0.9-0.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2-0.1-0.4-0.3-0.5c-0.2-0.1-0.4-0.2-0.8-0.2h-0.9V362.3z')
    //-   g
    //-     text(transform='matrix(1 0 0 1 109.2052 120.8002)')
    //-       tspan.st1.st2(x='0' y='0') GENERAL MARKET AGENCIES CHECK BOXES
    //-       tspan.st3.st2(x='377.3' y='0') .
    //-       tspan.st1.st2(x='383.3' y='0')  HISPANIC ONES CREATE THEM
    //-       tspan.st3.st2(x='655' y='0') .
    //-   text(transform='matrix(1 0 0 1 109.2071 185.4946)')
    //-     tspan.st4.st5(x='0' y='0') Long gone are the days when we looked at marketing from a binary perspective:
    //-     tspan.st4.st5(x='0' y='27.1') Black vs. White, English vs. Spanish and Non-Hispanic vs. Hispanic.
    //-     tspan.st4.st5(x='0' y='54.1') Cultures have blended and the process inside ad agencies should reflect that.
    //-   text.st1.st2(transform='matrix(1 0 0 1 109.2052 296.9194)') WE HAVE THE RIGHT APPROACH AND WE CALL IT
    //-   text.st4.st5(transform='matrix(1 0 0 1 109.2071 411.3412)') When Latin culture becomes pop culture, that&rsquo;s hipspanic
    //-   text.st4.st6(transform='matrix(0.583 0 0 0.583 483.5343 406.4282)') &reg;
    //-   text.st4.st5(transform='matrix(1 0 0 1 491.2843 411.3412)') .
    //-   text.st4.st5(transform='matrix(1 0 0 1 109.2071 438.393)') Doing work not from forced segmentations but from cultural integration.
    //-   text.st4.st5(transform='matrix(1 0 0 1 109.2071 465.4438)') Not from ethnic background but from cultural identity.
    //-   text.st4.st5(transform='matrix(1 0 0 1 109.2071 492.4955)') Not just from insights but from inside.
    //-   text(transform='matrix(1 0 0 1 109.2052 549.8979)')
    //-     tspan.st1.st2(x='0' y='0') IT MEANS WE LOOK BEYOND SPECIFIC SEGMENTS TO REACH
    //-     tspan.st1.st2(x='0' y='32') THOSE WHO ENJOY, TAKE PART OR ARE INSPIRED BY LATIN CULTURE
    //-     tspan.st3.st2(x='608.4' y='32') .
    //-   text.st4.st5(transform='matrix(1 0 0 1 109.2071 614.3657)')
    //-     | There&apos;s a big opportunity to reach consumers that expect brands to understand their search
    //-   text.st4.st5(transform='matrix(1 0 0 1 109.2071 641.4174)')
    //-     | for new culture and identity. We can help you talk to them. We worked at the top 5 advertising agencies
    //-   text.st4.st5(transform='matrix(1 0 0 1 109.2071 668.4682)') in the world and we happen to go to sleep and wake up hipspanic
    //-   text.st4.st6(transform='matrix(0.583 0 0 0.583 532.1798 663.5551)') &reg;
    //-   text.st4.st6(transform='matrix(1 0 0 1 539.9298 668.4682)') .
    //-   rect.st0(x='582.9' y='587' width='134.3' height='1.4')
    //-   g
    //-     text(transform='matrix(1 0 0 1 110.38 152.9741)')
    //-       tspan.st1.st2(x='0' y='0') WE&rsquo;RE NOT FANS OF EITHER
    //-       tspan.st3.st2(x='247.2' y='0') .
    //- svg(version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 1920 1080' style='enable-background:new 0 0 1920 1080;position: absolute;width: 47vw;bottom: -2.68vw;right: -12vw;' xml:space='preserve')
    //-   g
    //-     path(d='M1008.2,970V618.6c0-42.3-9.4-74.2-28.2-95.8c-18.9-21.5-45.6-32.3-80.1-32.3c-34.6,0-61.9,10.8-81.9,32.3\
    //-     c-20,21.6-30.1,53.5-30.1,95.8V970h-179V110h179v318.8c10.2-13.5,21.4-26.3,33.6-38.6c12.1-12.2,25.7-23.1,40.6-32.6\
    //-     c14.9-9.5,31.4-17,49.5-22.6c18.1-5.6,38.5-8.3,61.3-8.3c68.4,0,121.1,20.8,158.5,62.4c37.3,41.7,56,99,56,172V970H1008.2z')
    //-     g
    //-       path(d='M1168.2,326.7c5.6,0,10.1,1.8,13.7,5.5c3.6,3.7,5.4,8,5.4,13.1c0,5.1-1.8,9.5-5.5,13.1c-3.6,3.6-8,5.5-13.1,5.5\
    //-       c-5.1,0-9.5-1.8-13.2-5.4s-5.4-8-5.4-13.1c0-3.6,1-6.9,2.9-9.9c1.9-3,4.3-5.2,7.2-6.6C1163.1,327.4,1165.8,326.7,1168.2,326.7z\
    //-       M1169.2,330.3c-4.6,0-8.3,1.5-11.1,4.5c-2.8,3-4.2,6.5-4.2,10.5c0,4.1,1.5,7.6,4.4,10.6c2.9,2.9,6.4,4.4,10.6,4.4\
    //-       c4.1,0,7.6-1.5,10.5-4.4c2.9-2.9,4.4-6.4,4.4-10.6c0-2.8-0.7-5.4-2.2-7.8c-1.5-2.4-3.4-4.2-5.7-5.4\
    //-       C1173.5,330.9,1171.3,330.3,1169.2,330.3z M1160.5,355.2v-19.7h9.3c2.3,0,4,0.5,5,1.6c1.1,1.1,1.6,2.4,1.6,4\
    //-       c0,1.5-0.4,2.7-1.3,3.7c-0.9,0.9-2.2,1.5-4,1.9c0.8,0.3,1.5,0.7,1.9,1.3c0.5,0.5,1.2,1.7,2.3,3.4l2.3,4h-4.9l-1.6-3.2\
    //-       c-1-1.9-1.9-3.2-2.6-3.9c-0.8-0.7-1.7-1-2.9-1h-1v8.1H1160.5z M1164.5,344h3.3c1.6,0,2.8-0.2,3.5-0.6s1-1.1,1-2.1\
    //-       c0-0.9-0.3-1.5-1-2c-0.7-0.4-1.7-0.7-3.1-0.7h-3.7V344z')
  //#HipsWorks
    .row.relative
      i.material-icons.leftA.showHand(@click="selected = selected != 0 ? selected - 1 : 12" style="font-size:150%") chevron_left
      i.material-icons.rightA.showHand(@click="selected = selected != 12 ? selected + 1 : 0" style="font-size:150%") chevron_right
      .paddingLeft.col.normalSize.relative(style="z-index:10")
        br(style="font-size:30%")
        p.Fjalla
          span.blueLine This is what we're talking about.
        p.Oswald.smallerSize.showHand(style="margin-bottom: 6px; margin-top:2vw" v-on:click="$router.push('/work/' + media[selected].work);") Client: {{media[selected].client}}
        p.Oswald.smallestSize(v-if="media[selected].text" style="line-height:1.2; padding-right: 20vw; margin-top:6px" v-html="media[selected].text")
      .Media(style="width:100%; position: relative")
        div(v-if="media[selected].type=='video'")
          iframe.youtube(:src="media[selected].url" frameborder="0" allowfullscreen)
        div(v-if="media[selected].type=='banner'")
          img.youtube(:src="media[selected].url")
        div(v-if="media[selected].type=='imagesCols'").imgCols
          .col(v-for="p in media[selected].pictures" v-bind:class="{s3:media[selected].cols == 4, s4:media[selected].cols == 3}")
            img.image(:src="p")
      br
</template>

<script>
window.$ = require('jquery');
export default {
  data(){
    return {
      selected: 0,
      media: [
        {type: "video", work:"BUD LIGHT PARTY", url:"https://www.youtube.com/embed/-XqcfczdbW0?rel=0&showinfo=0", client:"BUD LIGHT", text:"First Spanish language Super Bowl commercial ever in 2016. "},
        {type: "video", work:"BUD LIGHT PARTY", url:"https://www.youtube.com/embed/eYauX_PxiVY?rel=0&showinfo=0", client:"BUD LIGHT", text:"We brought together a second generation Mexican-American Hollywood actor and a<br> Mexican soccer star to talk about the \"American Dream\" during Copa America 2016."},
        {type: "banner", work:"BUD LIGHT PARTY", url:"static/works/content/hips/BudLight_1.png", client:"BUD LIGHT"},
        {type: "banner", work:"BUD LIGHT PARTY", url:"static/works/content/hips/BudLight_2.png", client:"BUD LIGHT"},
        {type: "banner", work:"BUD LIGHT PARTY", url:"static/works/content/hips/BudLight_3.png", client:"BUD LIGHT"},
        {type: "banner", work:"BUD LIGHT PARTY", url:"static/works/content/hips/BudLight_4.png", client:"BUD LIGHT"},
        {type: "banner", work:"BUD LIGHT PARTY", url:"static/works/content/hips/BudLight_5.png", client:"BUD LIGHT"},
        {type: "video", work:"TARGET BABY", url:"https://player.vimeo.com/video/39199711?color=00FFFF&title=0&byline=0&portrait=0", client:"TARGET BABY", text:"Created TV and social media campaign targeting young Hispanic-American moms that navigate<br> between two cultures and languages. Work ran in general and hispanic market channels simultaneously."},
        {type: "video", work:"TARGET BABY", url:"https://player.vimeo.com/video/39198393?color=00FFFF&title=0&byline=0&portrait=0", client:"TARGET BABY", text:"Created TV and social media campaign targeting young Hispanic-American moms that navigate<br> between two cultures and languages. Work ran in general and hispanic market channels simultaneously."},
        {type: "banner", work:"TARGET BABY", url:"static/works/content/hips/TargetBaby.png", client:"TARGET BABY", text:"Created TV and social media campaign targeting young Hispanic-American moms that navigate<br> between two cultures and languages. Work ran in general and hispanic market channels simultaneously."},
        {type: "video", work:"KRAFT MACARONI & CHEESE", url:"https://www.youtube.com/embed/omu857aUS4g?rel=0&showinfo=0", client:"KRAFT MACARONI & CHEESE", text:"When you're a first generation parent, you don't only have to adapt to a new culture but also to your kid's bi-cultural taste."},
        {type: "video", work:"KRAFT MACARONI & CHEESE", url:"https://www.youtube.com/embed/zYTX8XZSV1M?rel=0&showinfo=0", client:"KRAFT MACARONI & CHEESE", text:"When you're a first generation parent, you don't only have to adapt to a new culture but also to your kid's bi-cultural taste."},
        {type: "banner", work:"KRAFT MACARONI & CHEESE", url:"/static/works/content/hips/KraftBanners.png", client:"KRAFT MACARONI & CHEESE", text:"When you're a first generation parent, you don't only have to adapt to a new culture but also to your kid's bi-cultural taste."},
      ]
    }
  },
  mounted(){
    setTimeout(()=>{
      //console.log($, $("#navbar a"))
      $("#navbar a").removeClass('active');
      $("#A-Hispanic").addClass('active');
    }, 100);
  }
}
</script>

<style lang="sass" scoped>
sup
  font-size: 40%
  top: -1.5em
.paddingLeft
  padding-left: 20vw !important
.bigPadd
  padding: 5px 0
#Header
  height: calc(100vw / 16 * 3.1)
  background: black
  img
    width: 28vw
#content
  background: black
  font-size: 2.7vw
  p
    //line-height: 1.3
    margin: 9px 0
  img#H
    position: absolute
    top: 50%
    transform: translate(-110%, -50%)
    height: 100%
  img#Heart
    position: absolute
    right: -0px
    bottom: 0px
    width: 30vw
#HipsWorks
  font-size: 2.7vw
  background-color: black
  padding: 0
  margin: 0
  color: white
  .youtube
    left: 17.5vw
    position: relative
    width: 65vw
    height: calc(65vw / 9 * 5)
    margin: 20px
  .blueLine
    position: relative
    &:after
      content: ''
      position: absolute
      width: 100%
      bottom: -4px
      left: 0px
      border-bottom: 0.3vw solid #00FFFF
      z-index: 90
  .row
    margin: 0
  i
    position: absolute
    z-index: 10000
    &.leftA
      top: 50%
      left: 10vw
      //transform: translate(0%, -50%)
    &.rightA
      top: 50%
      right: 10vw
      //transform: translate(0%, -50%)
.st0
  fill: #04FFFF
.st1
  font-family: 'Fjalla One', sans-serif
.st2
  font-size: 24.5903px
.st3
  font-family: 'Oswald', Icons
.st4
  font-family: 'Oswald', Icons
  font-weight: 300
  letter-spacing: 0.45px
.st5
  font-size: 18.0507px
.st6
  font-size: 14.7552px
</style>



// WEBPACK FOOTER //
// src/components/hispanic.vue